import React from "react";

export interface ProgressProps {
 value: number;
 max?: number;
 size?: "sm" | "md" | "lg";
 showLabel?: boolean;
 className?: string;
}

const sizeClasses = {
 sm: "h-1",
 md: "h-2",
 lg: "h-4",
};

export const Progress: React.FC<ProgressProps> = ({
 value,
 max = 100,
 size = "md",
 showLabel = false,
 className = "",
}) => {
 const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

 return (
  <div className={className}>
   {showLabel && (
    <div className="flex justify-between text-sm text-gray-700 mb-1">
     <span>Progress</span>
     <span>{Math.round(percentage)}%</span>
    </div>
   )}
   <div className={`w-full bg-gray-200 overflow-hidden ${sizeClasses[size]}`}>
    <div
     className="bg-blue-600 h-full transition-all duration-300 ease-out "
     style={{ width: `${percentage}%` }}
     role="progressbar"
     aria-valuenow={value}
     aria-valuemin={0}
     aria-valuemax={max}
    />
   </div>
  </div>
 );
};

export default Progress;

